(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["immortals-read-more"] && !Shopify.designMode) return;
  try {
    class ImmortalsReadMore extends HTMLElement {
    #viewport = null;
    #cta = null;
    #resizeObserver = null;
    #onCtaClick = null;

    connectedCallback() {
      this.#viewport = this.querySelector('.immortals-read-more__viewport');
      this.#cta = this.querySelector('.immortals-read-more__cta');

      if (!this.#viewport) return;

      if (this.#cta) {
        this.#onCtaClick = () => this.#expand();
        this.#cta.addEventListener('click', this.#onCtaClick);
      }

      this.#syncOverflowState();
      this.#resizeObserver = new ResizeObserver(() => this.#syncOverflowState());
      this.#resizeObserver.observe(this.#viewport);
    }

    disconnectedCallback() {
      if (this.#cta && this.#onCtaClick) {
        this.#cta.removeEventListener('click', this.#onCtaClick);
      }
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#viewport = null;
      this.#cta = null;
      this.#onCtaClick = null;
    }

    #expand() {
      if (!this.#viewport) return;
      this.#viewport.dataset.state = 'expanded';
      if (this.#cta) {
        this.#cta.setAttribute('aria-expanded', 'true');
        this.#cta.hidden = true;
      }
    }

    #syncOverflowState() {
      if (!this.#viewport) return;
      if (this.#viewport.dataset.state === 'expanded') return;

      const overflows = this.#viewport.scrollHeight > this.#viewport.clientHeight + 1;
      this.toggleAttribute('data-no-overflow', !overflows);

      if (this.#cta) {
        this.#cta.hidden = !overflows;
      }
    }
  }

  if (!customElements.get('immortals-read-more')) {
    customElements.define('immortals-read-more', ImmortalsReadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
